import { DATA_TYPES } from "common/constants/dataTypes";


export const MODEL_VAR_TYPES = {
	[DATA_TYPES.num.key]: DATA_TYPES.num,
	[DATA_TYPES.percent.key]: DATA_TYPES.percent,
	[DATA_TYPES.currency.key]: DATA_TYPES.currency,
	[DATA_TYPES.checkbox.key]: DATA_TYPES.checkbox,
}
